import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import ConditionalComponent from './ConditionalComponent';

const InstallerLinkComponent = ({
  build,
  onClick
}) => (
  <ConditionalComponent condition={build.is_prod}>
    <Row>
      <Col md={12}>
        <a
          id="copy-installer-button"
          onClick={() => onClick(build)}
        >
          Copy Installer Path
        </a>
      </Col>
    </Row>
  </ConditionalComponent>
);

InstallerLinkComponent.propTypes = {
  build: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default InstallerLinkComponent;


// WEBPACK FOOTER //
// src/Components/InstallerLinkComponent.jsx